export const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
//# sourceMappingURL=isBrowser.js.map